import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKS = [
  { label: "ABOUT", target: "#about" },
  { label: "PRODUCTS", target: "#products" },
  { label: "CONTACT US", target: "#contact" },
];

export const Header = ({ onNavigate }) => {
  const [open, setOpen] = useState(false);

  const go = (target) => {
    setOpen(false);
    onNavigate(target);
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 bg-white/70 backdrop-blur-xl border-b border-black/5 px-6 md:px-12"
    >
      <div className="max-w-[1400px] mx-auto h-[72px] flex items-center justify-between">
        <button
          data-testid="header-logo"
          onClick={() => go("body")}
          className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-slate-900"
        >
          TrioDocz<span className="text-slate-400">.</span>
        </button>

        <nav className="hidden md:flex items-center gap-10" data-testid="header-nav">
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => go(l.target)}
              className="text-xs font-semibold tracking-[0.2em] text-slate-600 hover:text-slate-900 transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="header-cta-button"
            onClick={() => go("#contact")}
            className="group flex items-center gap-2 bg-slate-900 text-white text-xs font-semibold tracking-[0.15em] px-5 py-2.5 rounded-full hover:bg-slate-700 transition-colors duration-300"
          >
            START A FILE
            <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-slate-900"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-black/5 px-6 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => go(l.target)}
              className="text-left text-sm font-semibold tracking-[0.2em] text-slate-700"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
